var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLogoDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_638",
    "data-name": "Raggruppa 638",
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.324,
    height: 71.085,
    viewBox: "0 0 85.324 71.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_637",
    "data-name": "Raggruppa 637",
    transform: "translate(28.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4069",
    "data-name": "Tracciato 4069",
    d: "M295.845,138.749l-6.07,6.069,25.5,25.5c3.694,3.695,9.72,4.4,13.765,1.094a9.992,9.992,0,0,0,.766-14.819L311.96,138.749A11.394,11.394,0,0,0,295.845,138.749Z",
    transform: "translate(-275.659 -135.411)",
    fill: "#1c395d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4070",
    "data-name": "Tracciato 4070",
    d: "M317.42,169.556l-25.9-25.9-10.778,10.779a11.394,11.394,0,0,0,0,16.115l17.842,17.843a9.989,9.989,0,0,1,0,14.127l7.064-7.063,18.836-18.837,7.064-7.064A9.99,9.99,0,0,1,317.42,169.556Z",
    transform: "translate(-277.403 -134.249)",
    fill: "#094795"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4071",
    "data-name": "Tracciato 4071",
    d: "M272.825,138.749,255.977,155.6a11.4,11.4,0,0,0,0,16.116l31.568,31.566c3.695,3.695,9.72,4.4,13.764,1.1a9.991,9.991,0,0,0,.766-14.819l-17.842-17.843a11.394,11.394,0,0,1,0-16.115l10.778-10.779-6.069-6.069A11.4,11.4,0,0,0,272.825,138.749ZM266,167.254a4.209,4.209,0,1,1,0-5.952A4.209,4.209,0,0,1,266,167.254Z",
    transform: "translate(-252.64 -135.411)",
    fill: "#3360ef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogoDashboard);
export default __webpack_public_path__ + "static/media/LoginLogoDashboard.093a356de9f63703c254381e1ec88c95.svg";
export { ForwardRef as ReactComponent };